import Vue from "vue";
import VueRouter from "vue-router";
import MainLayout from "@/layout/MainLayout.vue";
import SignPage from "@/views/pages/SignPage.vue";
import ErrorPage401 from "@/views/pages/ErrorPage401.vue";
import ErrorPage404 from "@/views/pages/ErrorPage404.vue";
import ErrorPage from "@/views/pages/ErrorPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: SignPage,
      },
      {
        path: "/unauthorized",
        component: ErrorPage401,
      },
      {
        path: "/error",
        component: ErrorPage,
      },
      {
        path: "*",
        component: ErrorPage404,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
